// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {apiKey: "AIzaSyAY44Zy-XYHVBEcVC71NJLxqt_oxIxx5lo",
  authDomain: "alcaldia-f7dd5.firebaseapp.com",
  databaseURL: "https://alcaldia-f7dd5.firebaseio.com",
  projectId: "alcaldia-f7dd5",
  storageBucket: "alcaldia-f7dd5.appspot.com",
  messagingSenderId: "147106065217"}

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
